import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { DeleteCustomTabModal } from "components/documents/modals/delete-custom-tab-modal";
import {
  deleteCustomTabAction,
  endDeleteCustomTabModeAction
} from "actions/custom-tabs-actions";

const MyDocumentsPage = (props) => (
  <div>
    { props.children }
    <DeleteCustomTabModal { ...props } />
  </div>
);

MyDocumentsPage.propTypes = {
  children: PropTypes.element.isRequired
};

const mapStateToProps = (state) => ({
  customTabRemoveId: state.customTabs.customTabRemoveId,
  isDeleteCustomTabLoading: state.customTabs.isDeleteCustomTabLoading,
  isDeleteCustomTabMode: state.customTabs.isDeleteCustomTabMode
});

const mapDispatchToProps = (dispatch) => ({
  onDeleteCustomTab: (id) => dispatch(deleteCustomTabAction(id)),
  onEndDeleteCustomTabMode: () => dispatch(endDeleteCustomTabModeAction())
});

export const MyDocumentsContainer = connect(mapStateToProps, mapDispatchToProps)(MyDocumentsPage);



// WEBPACK FOOTER //
// ./src/js/containers/my-documents-container.jsx